import { render, staticRenderFns } from "./Typhoon.vue?vue&type=template&id=72ab3824&"
import script from "./Typhoon.vue?vue&type=script&lang=js&"
export * from "./Typhoon.vue?vue&type=script&lang=js&"
import style0 from "./Typhoon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports